function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useState, useCallback } from 'react';
import { useControllableProp } from '../../hooks';
import { isInputEvent, addItem, removeItem } from '../../utils';
/**
 * React hook that provides all the state management logic
 * for a group of checkboxes.
 *
 * It is consumed by the `CheckboxGroup` component
 */
export function useCheckboxGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    defaultValue,
    value: valueProp,
    onChange: onChangeProp,
    isNative
  } = props;
  var [valueState, setValue] = useState(defaultValue || []);
  var [isControlled, value] = useControllableProp(valueProp, valueState);
  var updateValue = useCallback(nextState => {
    if (!isControlled) {
      setValue(nextState);
    }
    onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(nextState);
  }, [isControlled, onChangeProp]);
  var onChange = useCallback(eventOrValue => {
    if (!value) return;
    var isChecked = isInputEvent(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
    var selectedValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    var nextValue = isChecked ? addItem(value, selectedValue) : removeItem(value, selectedValue);
    updateValue(nextValue);
  }, [updateValue, value]);
  return {
    value,
    onChange,
    setValue: updateValue,
    getCheckboxProps: function getCheckboxProps() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var checkedKey = isNative ? 'checked' : 'isChecked';
      return _objectSpread(_objectSpread({}, props), {}, {
        [checkedKey]: value.includes(props.value),
        onChange
      });
    }
  };
}